<script setup lang="ts">
import type { AccordionPanelProps } from '@/shared/ui/Accordion/model/types/accordion';

const props = withDefaults(defineProps<AccordionPanelProps>(), {
  modelValue: true,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const isMobile: boolean = useIsMobile();

const clickHandler = (): void => {
  emit('update:modelValue', !props.modelValue);
};
</script>

<template>
  <button
    data-testid="accordion-panel"
    :class="[
      'app-collapse-accordion-panel',
      { _active: !modelValue },
      { _mobile: isMobile },
    ]"
    type="button"
    @click.prevent="clickHandler"
  >
    <span class="app-collapse-accordion-panel__wrapper">
      <slot></slot>
    </span>
    <div class="app-collapse-accordion-panel__right">
      <slot name="right"></slot>
      <div class="app-collapse-accordion-panel__icon-wrapper">
        <AppIcon
          name="ArrowDown"
          class="app-collapse-accordion-panel__icon"
          :width="iconWidth"
          :height="iconHeight"
        />
      </div>
    </div>
  </button>
</template>

<style lang="less">
.app-collapse-accordion-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  position: relative;
  z-index: 1;
  width: 100%;
  border-radius: @main-size;
  background-color: #fff;
  box-shadow: 0px @size-x10 @size-x10 -18px rgba(139, 144, 164, 0.1);
  transition: @A background-color;
  padding-right: @size-x8;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: @size-x8;
    padding: 38px @size-x6 38px 70px;
  }

  &__right {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    gap: @size-x5;
  }

  &__icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 50%;
    transform: rotate(0deg);
    transition: transform 0.2s linear;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: @size-x6;
    height: @size-x6;
  }

  &._active &__icon-wrapper {
    transform: rotate(180deg);
  }

  &._mobile {
    padding-right: @size-x5;
  }

  &._mobile &__wrapper {
    border-radius: @size-x5;
    padding: @size-x4 14px @size-x4 @size-x4;
  }

  &._mobile &__icon {
    width: @size-x4;
    height: @size-x4;
  }
}
</style>
